import { LogLevelEnum } from '@amaris/lib-highway/enums';

export const environment = {
  name: 'core',
  production: true,
  assetsPath: '/assets',
  logLevel: LogLevelEnum.Error,
  signalRUrl: '/signalr',
  apiUrl: '/api/v1',
  oAuth0Url: 'https://auth0.plaiad.com/api/v2',
  oAuthProvider: {
    domain: 'auth0.plaiad.com',
    clientId: 'f6AqtaEJlZ14bHcAuLRoOALxzr9zcxW8',
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: 'https://plaiad.eu.auth0.com/api/v2/',
      scope: 'openid profile email offline_access',
    },
  },
  stripe: {
    publicKey: 'pk_live_51OybGaDD19TY2CV1fZTpYcLPdUw7LxKmXNdq7l9U0vRWeC3r0ECJg2fMXhtqpkowGPr360vdm5MSEPo1Vd6djNuk00dvCqwsZC',
  },
};
